export default __webpack_public_path__ + "static/media/refill.c4b0d197.svg";